// source: messaging/camera_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var messaging_common_pb = require('../messaging/common_pb.js');
goog.object.extend(proto, messaging_common_pb);
goog.exportSymbol('proto.com.alfredcamera.protobuf.AccessPrioritySetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.AccessPrioritySetting.AccessPriorityMode', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.AutoPowerSavingSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraAliasSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraEnabledSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraLensSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraMicrophoneSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraSettingControls', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraSettingsRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.CameraSettingsResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ContinuousRecordingSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionModeSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionModeSetting.Sensitivity', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionReminderSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionScheduleSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionZoneSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.Shape', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LowLightFilterSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterMode', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterProfile', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.RotationSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.StatusLedSetting', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ZoomInLockSetting', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraLensSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraLensSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraLensSetting.displayName = 'proto.com.alfredcamera.protobuf.CameraLensSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraMicrophoneSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.displayName = 'proto.com.alfredcamera.protobuf.CameraMicrophoneSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraEnabledSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraEnabledSetting.displayName = 'proto.com.alfredcamera.protobuf.CameraEnabledSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraAliasSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraAliasSetting.displayName = 'proto.com.alfredcamera.protobuf.CameraAliasSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.LowLightFilterSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.LowLightFilterSetting.displayName = 'proto.com.alfredcamera.protobuf.LowLightFilterSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.AccessPrioritySetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.AccessPrioritySetting.displayName = 'proto.com.alfredcamera.protobuf.AccessPrioritySetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionModeSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionModeSetting.displayName = 'proto.com.alfredcamera.protobuf.DetectionModeSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionReminderSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionReminderSetting.displayName = 'proto.com.alfredcamera.protobuf.DetectionReminderSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionScheduleSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionScheduleSetting.displayName = 'proto.com.alfredcamera.protobuf.DetectionScheduleSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.alfredcamera.protobuf.DetectionZoneSetting.repeatedFields_, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionZoneSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.displayName = 'proto.com.alfredcamera.protobuf.DetectionZoneSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.repeatedFields_, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.displayName = 'proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.displayName = 'proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.displayName = 'proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ZoomInLockSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ZoomInLockSetting.displayName = 'proto.com.alfredcamera.protobuf.ZoomInLockSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ContinuousRecordingSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.displayName = 'proto.com.alfredcamera.protobuf.ContinuousRecordingSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.displayName = 'proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.AutoPowerSavingSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.displayName = 'proto.com.alfredcamera.protobuf.AutoPowerSavingSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.StatusLedSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.StatusLedSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.StatusLedSetting.displayName = 'proto.com.alfredcamera.protobuf.StatusLedSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.RotationSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.RotationSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.RotationSetting.displayName = 'proto.com.alfredcamera.protobuf.RotationSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraSettingsRequest.displayName = 'proto.com.alfredcamera.protobuf.CameraSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.CameraSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.CameraSettingsResponse.displayName = 'proto.com.alfredcamera.protobuf.CameraSettingsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraLensSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraLensSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    lensId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraLensSetting}
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraLensSetting;
  return proto.com.alfredcamera.protobuf.CameraLensSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraLensSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraLensSetting}
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLensId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraLensSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraLensSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLensId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 lens_id = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.prototype.getLensId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraLensSetting} returns this
 */
proto.com.alfredcamera.protobuf.CameraLensSetting.prototype.setLensId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraMicrophoneSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraMicrophoneSetting}
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraMicrophoneSetting;
  return proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraMicrophoneSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraMicrophoneSetting}
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraMicrophoneSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.CameraMicrophoneSetting} returns this
 */
proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraEnabledSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraEnabledSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraEnabledSetting}
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraEnabledSetting;
  return proto.com.alfredcamera.protobuf.CameraEnabledSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraEnabledSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraEnabledSetting}
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraEnabledSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraEnabledSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.CameraEnabledSetting} returns this
 */
proto.com.alfredcamera.protobuf.CameraEnabledSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraAliasSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraAliasSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    alias: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraAliasSetting}
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraAliasSetting;
  return proto.com.alfredcamera.protobuf.CameraAliasSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraAliasSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraAliasSetting}
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraAliasSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraAliasSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string alias = 1;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.CameraAliasSetting} returns this
 */
proto.com.alfredcamera.protobuf.CameraAliasSetting.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.LowLightFilterSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.LowLightFilterSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    profile: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.LowLightFilterSetting}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.LowLightFilterSetting;
  return proto.com.alfredcamera.protobuf.LowLightFilterSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.LowLightFilterSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.LowLightFilterSetting}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterProfile} */ (reader.readEnum());
      msg.setProfile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.LowLightFilterSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.LowLightFilterSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProfile();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterMode = {
  OFF: 0,
  ON: 1,
  AUTO: 2
};

/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterProfile = {
  DEFAULT: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

/**
 * optional LowLightFilterMode mode = 1;
 * @return {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterMode}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.prototype.getMode = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterMode} value
 * @return {!proto.com.alfredcamera.protobuf.LowLightFilterSetting} returns this
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional LowLightFilterProfile profile = 2;
 * @return {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterProfile}
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.prototype.getProfile = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterProfile} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.LowLightFilterSetting.LowLightFilterProfile} value
 * @return {!proto.com.alfredcamera.protobuf.LowLightFilterSetting} returns this
 */
proto.com.alfredcamera.protobuf.LowLightFilterSetting.prototype.setProfile = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.AccessPrioritySetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.AccessPrioritySetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.AccessPrioritySetting}
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.AccessPrioritySetting;
  return proto.com.alfredcamera.protobuf.AccessPrioritySetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.AccessPrioritySetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.AccessPrioritySetting}
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.AccessPrioritySetting.AccessPriorityMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.AccessPrioritySetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.AccessPrioritySetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.AccessPriorityMode = {
  ALWAYS_ACCEPT: 0,
  OWNER_FIRST: 1,
  ALWAYS_REJECT: 2
};

/**
 * optional AccessPriorityMode mode = 1;
 * @return {!proto.com.alfredcamera.protobuf.AccessPrioritySetting.AccessPriorityMode}
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.prototype.getMode = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.AccessPrioritySetting.AccessPriorityMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.AccessPrioritySetting.AccessPriorityMode} value
 * @return {!proto.com.alfredcamera.protobuf.AccessPrioritySetting} returns this
 */
proto.com.alfredcamera.protobuf.AccessPrioritySetting.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionModeSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionModeSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    mode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sensitivity: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionModeSetting;
  return proto.com.alfredcamera.protobuf.DetectionModeSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionModeSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 3:
      var value = /** @type {!proto.com.alfredcamera.protobuf.DetectionModeSetting.Sensitivity} */ (reader.readEnum());
      msg.setSensitivity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionModeSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionModeSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSensitivity();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode = {
  DISABLED: 0,
  MOTION: 1,
  PERSON: 2
};

/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.Sensitivity = {
  DEFAULT: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional DetectionMode mode = 2;
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.getMode = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.DetectionModeSetting.DetectionMode} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Sensitivity sensitivity = 3;
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting.Sensitivity}
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.getSensitivity = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.DetectionModeSetting.Sensitivity} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.DetectionModeSetting.Sensitivity} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionModeSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionModeSetting.prototype.setSensitivity = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionReminderSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionReminderSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionReminderSetting}
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionReminderSetting;
  return proto.com.alfredcamera.protobuf.DetectionReminderSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionReminderSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionReminderSetting}
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionReminderSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionReminderSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionReminderSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionReminderSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionScheduleSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    schedule: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting}
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionScheduleSetting;
  return proto.com.alfredcamera.protobuf.DetectionScheduleSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting}
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionScheduleSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSchedule();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string schedule = 2;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.prototype.getSchedule = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionScheduleSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionScheduleSetting.prototype.setSchedule = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    zonesList: jspb.Message.toObjectList(msg.getZonesList(),
    proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.toObject, includeInstance),
    shapeType: (f = msg.getShapeType()) && proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionZoneSetting;
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = new proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.deserializeBinaryFromReader);
      msg.addZones(value);
      break;
    case 3:
      var value = new proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.deserializeBinaryFromReader);
      msg.setShapeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getZonesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.serializeBinaryToWriter
    );
  }
  f = message.getShapeType();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    activated: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    coordinateList: jspb.Message.toObjectList(msg.getCoordinateList(),
    proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig;
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActivated(value);
      break;
    case 2:
      var value = new proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.deserializeBinaryFromReader);
      msg.addCoordinate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivated();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCoordinateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.toObject = function(includeInstance, msg) {
  var f, obj = {
    x: jspb.Message.getFieldWithDefault(msg, 1, 0),
    y: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate;
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 x = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.prototype.setX = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 y = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate.prototype.setY = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool activated = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.getActivated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.setActivated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated Coordinate coordinate = 2;
 * @return {!Array<!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate>}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.getCoordinateList = function() {
  return /** @type{!Array<!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate, 2));
};


/**
 * @param {!Array<!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate>} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig} returns this
*/
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.setCoordinateList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.addCoordinate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.Coordinate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig.prototype.clearCoordinateList = function() {
  return this.setCoordinateList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape;
  return proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.Shape} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.Shape = {
  POLYGON: 0,
  RECTANGLE: 1
};

/**
 * optional Shape type = 1;
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.Shape}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.prototype.getType = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.Shape} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.Shape} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated ZoneConfig zones = 2;
 * @return {!Array<!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig>}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.getZonesList = function() {
  return /** @type{!Array<!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig, 2));
};


/**
 * @param {!Array<!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig>} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} returns this
*/
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.setZonesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.addZones = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.alfredcamera.protobuf.DetectionZoneSetting.ZoneConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.clearZonesList = function() {
  return this.setZonesList([]);
};


/**
 * optional SupportedShape shape_type = 3;
 * @return {?proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.getShapeType = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape, 3));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.DetectionZoneSetting.SupportedShape|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} returns this
*/
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.setShapeType = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.DetectionZoneSetting} returns this
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.clearShapeType = function() {
  return this.setShapeType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.DetectionZoneSetting.prototype.hasShapeType = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ZoomInLockSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ZoomInLockSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ZoomInLockSetting}
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ZoomInLockSetting;
  return proto.com.alfredcamera.protobuf.ZoomInLockSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ZoomInLockSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ZoomInLockSetting}
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ZoomInLockSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ZoomInLockSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomInLockSetting} returns this
 */
proto.com.alfredcamera.protobuf.ZoomInLockSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ContinuousRecordingSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSetting}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ContinuousRecordingSetting;
  return proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ContinuousRecordingSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSetting}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ContinuousRecordingSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSetting} returns this
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && messaging_common_pb.OperationResult.toObject(includeInstance, f),
    availableSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    availableDuration: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse;
  return proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new messaging_common_pb.OperationResult;
      reader.readMessage(value,messaging_common_pb.OperationResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAvailableSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAvailableDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messaging_common_pb.OperationResult.serializeBinaryToWriter
    );
  }
  f = message.getAvailableSize();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getAvailableDuration();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional OperationResult result = 1;
 * @return {?proto.com.alfredcamera.protobuf.OperationResult}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.getResult = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.OperationResult} */ (
    jspb.Message.getWrapperField(this, messaging_common_pb.OperationResult, 1));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.OperationResult|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} returns this
*/
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} returns this
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 available_size = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.getAvailableSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} returns this
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.setAvailableSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 available_duration = 3;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.getAvailableDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse} returns this
 */
proto.com.alfredcamera.protobuf.ContinuousRecordingSettingResponse.prototype.setAvailableDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.AutoPowerSavingSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.AutoPowerSavingSetting}
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.AutoPowerSavingSetting;
  return proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.AutoPowerSavingSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.AutoPowerSavingSetting}
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.AutoPowerSavingSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.AutoPowerSavingSetting} returns this
 */
proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.StatusLedSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.StatusLedSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.StatusLedSetting}
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.StatusLedSetting;
  return proto.com.alfredcamera.protobuf.StatusLedSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.StatusLedSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.StatusLedSetting}
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.StatusLedSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.StatusLedSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.StatusLedSetting} returns this
 */
proto.com.alfredcamera.protobuf.StatusLedSetting.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.RotationSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.RotationSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.RotationSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.RotationSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    degree: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.RotationSetting}
 */
proto.com.alfredcamera.protobuf.RotationSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.RotationSetting;
  return proto.com.alfredcamera.protobuf.RotationSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.RotationSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.RotationSetting}
 */
proto.com.alfredcamera.protobuf.RotationSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDegree(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.RotationSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.RotationSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.RotationSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.RotationSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDegree();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 degree = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.RotationSetting.prototype.getDegree = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.RotationSetting} returns this
 */
proto.com.alfredcamera.protobuf.RotationSetting.prototype.setDegree = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsRequest}
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraSettingsRequest;
  return proto.com.alfredcamera.protobuf.CameraSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsRequest}
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.CameraSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    settingsRevision: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cameraLensSetting: (f = msg.getCameraLensSetting()) && proto.com.alfredcamera.protobuf.CameraLensSetting.toObject(includeInstance, f),
    cameraEnabledSetting: (f = msg.getCameraEnabledSetting()) && proto.com.alfredcamera.protobuf.CameraEnabledSetting.toObject(includeInstance, f),
    cameraAliasSetting: (f = msg.getCameraAliasSetting()) && proto.com.alfredcamera.protobuf.CameraAliasSetting.toObject(includeInstance, f),
    lowlightFilterSetting: (f = msg.getLowlightFilterSetting()) && proto.com.alfredcamera.protobuf.LowLightFilterSetting.toObject(includeInstance, f),
    accessPrioritySetting: (f = msg.getAccessPrioritySetting()) && proto.com.alfredcamera.protobuf.AccessPrioritySetting.toObject(includeInstance, f),
    detectionModeSetting: (f = msg.getDetectionModeSetting()) && proto.com.alfredcamera.protobuf.DetectionModeSetting.toObject(includeInstance, f),
    continuousRecordingSetting: (f = msg.getContinuousRecordingSetting()) && proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.toObject(includeInstance, f),
    autoPowerSavingSetting: (f = msg.getAutoPowerSavingSetting()) && proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.toObject(includeInstance, f),
    cameraMicrophoneSetting: (f = msg.getCameraMicrophoneSetting()) && proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.toObject(includeInstance, f),
    rotationSetting: (f = msg.getRotationSetting()) && proto.com.alfredcamera.protobuf.RotationSetting.toObject(includeInstance, f),
    detectionReminderSetting: (f = msg.getDetectionReminderSetting()) && proto.com.alfredcamera.protobuf.DetectionReminderSetting.toObject(includeInstance, f),
    detectionScheduleSetting: (f = msg.getDetectionScheduleSetting()) && proto.com.alfredcamera.protobuf.DetectionScheduleSetting.toObject(includeInstance, f),
    detectionZoneSetting: (f = msg.getDetectionZoneSetting()) && proto.com.alfredcamera.protobuf.DetectionZoneSetting.toObject(includeInstance, f),
    zoomInLockSetting: (f = msg.getZoomInLockSetting()) && proto.com.alfredcamera.protobuf.ZoomInLockSetting.toObject(includeInstance, f),
    statusLedSetting: (f = msg.getStatusLedSetting()) && proto.com.alfredcamera.protobuf.StatusLedSetting.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.CameraSettingsResponse;
  return proto.com.alfredcamera.protobuf.CameraSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSettingsRevision(value);
      break;
    case 2:
      var value = new proto.com.alfredcamera.protobuf.CameraLensSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraLensSetting.deserializeBinaryFromReader);
      msg.setCameraLensSetting(value);
      break;
    case 3:
      var value = new proto.com.alfredcamera.protobuf.CameraEnabledSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraEnabledSetting.deserializeBinaryFromReader);
      msg.setCameraEnabledSetting(value);
      break;
    case 4:
      var value = new proto.com.alfredcamera.protobuf.CameraAliasSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraAliasSetting.deserializeBinaryFromReader);
      msg.setCameraAliasSetting(value);
      break;
    case 5:
      var value = new proto.com.alfredcamera.protobuf.LowLightFilterSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.LowLightFilterSetting.deserializeBinaryFromReader);
      msg.setLowlightFilterSetting(value);
      break;
    case 6:
      var value = new proto.com.alfredcamera.protobuf.AccessPrioritySetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.AccessPrioritySetting.deserializeBinaryFromReader);
      msg.setAccessPrioritySetting(value);
      break;
    case 7:
      var value = new proto.com.alfredcamera.protobuf.DetectionModeSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionModeSetting.deserializeBinaryFromReader);
      msg.setDetectionModeSetting(value);
      break;
    case 8:
      var value = new proto.com.alfredcamera.protobuf.ContinuousRecordingSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.deserializeBinaryFromReader);
      msg.setContinuousRecordingSetting(value);
      break;
    case 9:
      var value = new proto.com.alfredcamera.protobuf.AutoPowerSavingSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.deserializeBinaryFromReader);
      msg.setAutoPowerSavingSetting(value);
      break;
    case 10:
      var value = new proto.com.alfredcamera.protobuf.CameraMicrophoneSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.deserializeBinaryFromReader);
      msg.setCameraMicrophoneSetting(value);
      break;
    case 11:
      var value = new proto.com.alfredcamera.protobuf.RotationSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.RotationSetting.deserializeBinaryFromReader);
      msg.setRotationSetting(value);
      break;
    case 16:
      var value = new proto.com.alfredcamera.protobuf.DetectionReminderSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionReminderSetting.deserializeBinaryFromReader);
      msg.setDetectionReminderSetting(value);
      break;
    case 17:
      var value = new proto.com.alfredcamera.protobuf.DetectionScheduleSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionScheduleSetting.deserializeBinaryFromReader);
      msg.setDetectionScheduleSetting(value);
      break;
    case 18:
      var value = new proto.com.alfredcamera.protobuf.DetectionZoneSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.DetectionZoneSetting.deserializeBinaryFromReader);
      msg.setDetectionZoneSetting(value);
      break;
    case 19:
      var value = new proto.com.alfredcamera.protobuf.ZoomInLockSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.ZoomInLockSetting.deserializeBinaryFromReader);
      msg.setZoomInLockSetting(value);
      break;
    case 64:
      var value = new proto.com.alfredcamera.protobuf.StatusLedSetting;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.StatusLedSetting.deserializeBinaryFromReader);
      msg.setStatusLedSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.CameraSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettingsRevision();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCameraLensSetting();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.alfredcamera.protobuf.CameraLensSetting.serializeBinaryToWriter
    );
  }
  f = message.getCameraEnabledSetting();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.alfredcamera.protobuf.CameraEnabledSetting.serializeBinaryToWriter
    );
  }
  f = message.getCameraAliasSetting();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.alfredcamera.protobuf.CameraAliasSetting.serializeBinaryToWriter
    );
  }
  f = message.getLowlightFilterSetting();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.com.alfredcamera.protobuf.LowLightFilterSetting.serializeBinaryToWriter
    );
  }
  f = message.getAccessPrioritySetting();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.com.alfredcamera.protobuf.AccessPrioritySetting.serializeBinaryToWriter
    );
  }
  f = message.getDetectionModeSetting();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.com.alfredcamera.protobuf.DetectionModeSetting.serializeBinaryToWriter
    );
  }
  f = message.getContinuousRecordingSetting();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.com.alfredcamera.protobuf.ContinuousRecordingSetting.serializeBinaryToWriter
    );
  }
  f = message.getAutoPowerSavingSetting();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.com.alfredcamera.protobuf.AutoPowerSavingSetting.serializeBinaryToWriter
    );
  }
  f = message.getCameraMicrophoneSetting();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.com.alfredcamera.protobuf.CameraMicrophoneSetting.serializeBinaryToWriter
    );
  }
  f = message.getRotationSetting();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.com.alfredcamera.protobuf.RotationSetting.serializeBinaryToWriter
    );
  }
  f = message.getDetectionReminderSetting();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.com.alfredcamera.protobuf.DetectionReminderSetting.serializeBinaryToWriter
    );
  }
  f = message.getDetectionScheduleSetting();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.com.alfredcamera.protobuf.DetectionScheduleSetting.serializeBinaryToWriter
    );
  }
  f = message.getDetectionZoneSetting();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.com.alfredcamera.protobuf.DetectionZoneSetting.serializeBinaryToWriter
    );
  }
  f = message.getZoomInLockSetting();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.com.alfredcamera.protobuf.ZoomInLockSetting.serializeBinaryToWriter
    );
  }
  f = message.getStatusLedSetting();
  if (f != null) {
    writer.writeMessage(
      64,
      f,
      proto.com.alfredcamera.protobuf.StatusLedSetting.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 settings_revision = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getSettingsRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setSettingsRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CameraLensSetting camera_lens_setting = 2;
 * @return {?proto.com.alfredcamera.protobuf.CameraLensSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getCameraLensSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraLensSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraLensSetting, 2));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraLensSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setCameraLensSetting = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearCameraLensSetting = function() {
  return this.setCameraLensSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasCameraLensSetting = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CameraEnabledSetting camera_enabled_setting = 3;
 * @return {?proto.com.alfredcamera.protobuf.CameraEnabledSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getCameraEnabledSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraEnabledSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraEnabledSetting, 3));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraEnabledSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setCameraEnabledSetting = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearCameraEnabledSetting = function() {
  return this.setCameraEnabledSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasCameraEnabledSetting = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CameraAliasSetting camera_alias_setting = 4;
 * @return {?proto.com.alfredcamera.protobuf.CameraAliasSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getCameraAliasSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraAliasSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraAliasSetting, 4));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraAliasSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setCameraAliasSetting = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearCameraAliasSetting = function() {
  return this.setCameraAliasSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasCameraAliasSetting = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional LowLightFilterSetting lowlight_filter_setting = 5;
 * @return {?proto.com.alfredcamera.protobuf.LowLightFilterSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getLowlightFilterSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.LowLightFilterSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.LowLightFilterSetting, 5));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.LowLightFilterSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setLowlightFilterSetting = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearLowlightFilterSetting = function() {
  return this.setLowlightFilterSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasLowlightFilterSetting = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AccessPrioritySetting access_priority_setting = 6;
 * @return {?proto.com.alfredcamera.protobuf.AccessPrioritySetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getAccessPrioritySetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.AccessPrioritySetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.AccessPrioritySetting, 6));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.AccessPrioritySetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setAccessPrioritySetting = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearAccessPrioritySetting = function() {
  return this.setAccessPrioritySetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasAccessPrioritySetting = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional DetectionModeSetting detection_mode_setting = 7;
 * @return {?proto.com.alfredcamera.protobuf.DetectionModeSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getDetectionModeSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.DetectionModeSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.DetectionModeSetting, 7));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.DetectionModeSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setDetectionModeSetting = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearDetectionModeSetting = function() {
  return this.setDetectionModeSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasDetectionModeSetting = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ContinuousRecordingSetting continuous_recording_setting = 8;
 * @return {?proto.com.alfredcamera.protobuf.ContinuousRecordingSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getContinuousRecordingSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.ContinuousRecordingSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.ContinuousRecordingSetting, 8));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.ContinuousRecordingSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setContinuousRecordingSetting = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearContinuousRecordingSetting = function() {
  return this.setContinuousRecordingSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasContinuousRecordingSetting = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional AutoPowerSavingSetting auto_power_saving_setting = 9;
 * @return {?proto.com.alfredcamera.protobuf.AutoPowerSavingSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getAutoPowerSavingSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.AutoPowerSavingSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.AutoPowerSavingSetting, 9));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.AutoPowerSavingSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setAutoPowerSavingSetting = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearAutoPowerSavingSetting = function() {
  return this.setAutoPowerSavingSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasAutoPowerSavingSetting = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CameraMicrophoneSetting camera_microphone_setting = 10;
 * @return {?proto.com.alfredcamera.protobuf.CameraMicrophoneSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getCameraMicrophoneSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.CameraMicrophoneSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.CameraMicrophoneSetting, 10));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.CameraMicrophoneSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setCameraMicrophoneSetting = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearCameraMicrophoneSetting = function() {
  return this.setCameraMicrophoneSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasCameraMicrophoneSetting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional RotationSetting rotation_setting = 11;
 * @return {?proto.com.alfredcamera.protobuf.RotationSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getRotationSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.RotationSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.RotationSetting, 11));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.RotationSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setRotationSetting = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearRotationSetting = function() {
  return this.setRotationSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasRotationSetting = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DetectionReminderSetting detection_reminder_setting = 16;
 * @return {?proto.com.alfredcamera.protobuf.DetectionReminderSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getDetectionReminderSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.DetectionReminderSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.DetectionReminderSetting, 16));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.DetectionReminderSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setDetectionReminderSetting = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearDetectionReminderSetting = function() {
  return this.setDetectionReminderSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasDetectionReminderSetting = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional DetectionScheduleSetting detection_schedule_setting = 17;
 * @return {?proto.com.alfredcamera.protobuf.DetectionScheduleSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getDetectionScheduleSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.DetectionScheduleSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.DetectionScheduleSetting, 17));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.DetectionScheduleSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setDetectionScheduleSetting = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearDetectionScheduleSetting = function() {
  return this.setDetectionScheduleSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasDetectionScheduleSetting = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional DetectionZoneSetting detection_zone_setting = 18;
 * @return {?proto.com.alfredcamera.protobuf.DetectionZoneSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getDetectionZoneSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.DetectionZoneSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.DetectionZoneSetting, 18));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.DetectionZoneSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setDetectionZoneSetting = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearDetectionZoneSetting = function() {
  return this.setDetectionZoneSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasDetectionZoneSetting = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional ZoomInLockSetting zoom_in_lock_setting = 19;
 * @return {?proto.com.alfredcamera.protobuf.ZoomInLockSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getZoomInLockSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.ZoomInLockSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.ZoomInLockSetting, 19));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.ZoomInLockSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setZoomInLockSetting = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearZoomInLockSetting = function() {
  return this.setZoomInLockSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasZoomInLockSetting = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional StatusLedSetting status_led_setting = 64;
 * @return {?proto.com.alfredcamera.protobuf.StatusLedSetting}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.getStatusLedSetting = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.StatusLedSetting} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.StatusLedSetting, 64));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.StatusLedSetting|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
*/
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.setStatusLedSetting = function(value) {
  return jspb.Message.setWrapperField(this, 64, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.CameraSettingsResponse} returns this
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.clearStatusLedSetting = function() {
  return this.setStatusLedSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.CameraSettingsResponse.prototype.hasStatusLedSetting = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.CameraSettingControls = {
  ALL_SETTINGS: 0,
  LENS: 1,
  ENABLE: 2,
  ALIAS: 3,
  LOWLIGHT_FILTER: 4,
  ACCESS_PRIORITY: 5,
  DETECTION_MODE: 6,
  MICROPHONE: 7,
  ROTATION: 8,
  OSD: 9,
  DETECTION_REMINDER: 16,
  DETECTION_SCHEDULE: 17,
  DETECTION_ZONE: 18,
  ZOOM_IN_LOCK: 19,
  CONTINUOUS_RECORDING: 20,
  AUTO_POWER_SAVING: 21,
  STATUS_LED: 64
};

goog.object.extend(exports, proto.com.alfredcamera.protobuf);
